





































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class StandertIconsGroup extends Vue {
  @Prop({ type: Array, default: () => [] }) icons!: Array<string>;
  @Prop({ type: String, default: "" }) folder!: string;

  active = "";

  change(img: string): void {
    this.active = img;
    this.$emit("change", img);
  }
}
